import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'

import { store } from 'store'
import App from './App'

const root = document.getElementById('root')

if (root) {
  createRoot(root).render(
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  )
}
